/**
 * Decorator that adds styles to a component.
 *
 * Tracks the styles of a component and extends them with the styles of its super classes.
 *
 * @param s The styles to add to the component.
 * @returns Decorator.
 */
export const styles = (...s) => {
    return (constructor) => {
        const protoStyles = [];
        for (let superClass = Object.getPrototypeOf(constructor); superClass.styles; superClass = Object.getPrototypeOf(superClass)) {
            protoStyles.push(superClass.styles);
        }
        constructor.styles = [...protoStyles, ...s];
    };
};
//# sourceMappingURL=styles.js.map